module.exports = __webpack_public_path__ + "img/dataTypeShort.4990d864.png";